import { whiteColor, rowHoverColor,primaryColor, borderColor } from 'assets/jss/material-dashboard-pro-react';

const customTableComponentStyle = () => ({
	fbbTableWrapper: {
		paddingTop: '30px',
		marginBottom: '20px',
		'& .MuiTableCell-root': {
			padding: '0px !important',
			paddingLeft: '5px !important',
			border: `1px solid ${borderColor}`,
			textAlign: 'center'
		},
		'& .MuiTableRow-root': {
			cursor: 'pointer',
			'& .MuiTableCell-root:first-child': {
				border: 'none',
				backgroundColor: whiteColor
			},
		},
		'& .MuiTableBody-root': {
			'& .MuiTableRow-root:hover .MuiTableCell-root': {
				backgroundColor: rowHoverColor
			}
		}
	},
	tableHead: {
		'& .MuiTableCell-head': {
			color: whiteColor,
			backgroundColor: primaryColor[0],
			padding: '5px !important',
		},
		'& .MuiTableCell-head:nth-child(1)': {
			backgroundColor: whiteColor,
			width: '80px'
		}

	}
});

export default customTableComponentStyle;
